import { Routes, Route, Navigate } from 'react-router-dom'
import { Frame } from '@shopify/polaris'
import { Toaster } from 'react-hot-toast'

import { useAuth } from './contexts/AuthContext'
import { Navigation } from './components/Navigation'
import { LoadingSpinner } from './components/LoadingSpinner'

// Pages
import LoginPage from './pages/LoginPage'
import WorkspaceSignupPage from './pages/WorkspaceSignupPage'
import DashboardPage from './pages/DashboardPage'
import ConversationsPage from './pages/ConversationsPage'
import ConversationDetailPage from './pages/ConversationDetailPage'
import CustomersPage from './pages/CustomersPage'
import AnalyticsPage from './pages/AnalyticsPage'
import SettingsPage from './pages/SettingsPage'
import SetupPage from './pages/SetupPage'
import BillingPlanSelectPage from './pages/BillingPlanSelectPage'
import BillingCallbackPage from './pages/BillingCallbackPage'
import WorkflowsPage from './pages/WorkflowsPage'
import WorkflowBuilderPage from './pages/WorkflowBuilderPage'
import WorkflowTemplatesPage from './pages/WorkflowTemplatesPage'
import { InteractiveMessagesPage } from './pages/InteractiveMessagesPage'
import QRCodePage from './pages/QRCodePage'
import VerificationGuidePage from './pages/VerificationGuidePage'
import CODPage from './pages/CODPage'
import { CatalogManagementPage } from './pages/CatalogManagementPage'
import ReviewsPage from './pages/Reviews'
import TeamRoutingPage from './pages/TeamRoutingPage'
import TeamPage from './pages/TeamPage'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<WorkspaceSignupPage />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/billing/select-plan" element={<BillingPlanSelectPage />} />
        <Route path="/billing/callback" element={<BillingCallbackPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Frame navigation={<Navigation />}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/conversations" element={<ConversationsPage />} />
        <Route path="/conversations/:id" element={<ConversationDetailPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/interactive" element={<InteractiveMessagesPage storeId={user?.storeId || ''} />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/workflows" element={<WorkflowsPage />} />
        <Route path="/workflows/templates" element={<WorkflowTemplatesPage />} />
        <Route path="/workflows/:id" element={<WorkflowBuilderPage />} />
        <Route path="/qr-codes" element={<QRCodePage />} />
        <Route path="/verification" element={<VerificationGuidePage />} />
        <Route path="/cod" element={<CODPage />} />
        <Route path="/catalog" element={<CatalogManagementPage />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/team-routing" element={<TeamRoutingPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/billing/select-plan" element={<BillingPlanSelectPage />} />
        <Route path="/billing/callback" element={<BillingCallbackPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <Toaster position="top-right" />
    </Frame>
  )
}

export default App